import React from 'react';

export const RangeInput = props => {
	return (
		<div className="range-input">
			<p className="range-field">
				<input type="range" id={props.id} value={props.value} min={props.min} max={props.max} onChange={props.changeAction} />
			</p>
		</div>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/RangeInput.js